import React from "react";
import { PageHeader } from "./PageHeader"
import { DataBox } from "./DataBox"
import { Print } from "./Print"
import { PrintSa } from "./PrintSa"

export default () => {
    return (
        <>
            <PageHeader />
            <DataBox />
            {/* <Print /> */}
            <PrintSa />
        </>
    )
}